/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Tabs,
  Modal,
  DatePicker,
} from 'antd';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import { getEstadosGlobales } from 'api/catalogos/index';
import Table from 'components/Table';
import {
  getEvaluacionesAsistencia,
} from 'api/catalogos/TiposDeEvaluacionAsistencia';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_INACTIVO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  autorizarIncidenciaGeneral,
  deleteIncidenciaGeneral,
  getIncidenciaGeneral, getIncidenciasGenerales, patchIncidenciaGeneral, postIncidenciaGeneral,
} from 'api/configuraciones/clock/Incidencias/IncidenciaGeneral';
import { formatReceived } from 'utils/formatValues';
import moment from 'moment/moment';

export const incidenciaGeneralPermission = {
  permissionModel: 'incidenciageneral',
  catalogsModels: [],
  tabsModels: [],
};

const IncidenciaGeneral = ({ permission }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [evaluacionesAsistencia, setEvaluacionesAsistencia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getIncidenciasGenerales();
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _evaluacionesAsistencia,
        _data,
        _estados,
      ] = await Promise.all([
        getEvaluacionesAsistencia({ estados_globales: ESTATUS_AUTORIZADO }),
        getIncidenciasGenerales(),
        getEstadosGlobales(),
      ]);
      if (mounted) {
        setEvaluacionesAsistencia(_evaluacionesAsistencia);
        setData(_data);
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _incidenciaGeneral = await getIncidenciaGeneral(match.id);

    if (!evaluacionesAsistencia.length) {
      await getEvaluacionesAsistencia({ estados_globales: ESTATUS_AUTORIZADO }).then(setEvaluacionesAsistencia);
    }

    setTimeout(() => {
      if (_incidenciaGeneral) {
        const formValues = {
          // Formatea la información recibida (según lógica definida en formatReceived)
          ...formatReceived(_incidenciaGeneral),

          // Convierte el arreglo de tipos de evaluación de asistencia en un arreglo de IDs
          tipos_de_evaluacion_de_asistencia: (_incidenciaGeneral.tipos_de_evaluacion_de_asistencia || []).map((t) => t.id),

          // Convierte la fecha de vigencia final a objeto moment si existe, si no null
          vigencia_final: _incidenciaGeneral.vigencia_final
            ? moment(_incidenciaGeneral.vigencia_final)
            : null,

          // Asigna el ID del estado global
          estados_globales: _incidenciaGeneral.estados_globales?.id, //  aquí sí es un ID
        };
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setDisableFields(_incidenciaGeneral?.estados_globales?.id !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      if (values.vigencia_final?.format) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }
      const saved = await (key ? patchIncidenciaGeneral(key, values) : postIncidenciaGeneral(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteIncidenciaGeneral(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Incidencia General ya autorizado');
        return;
      }
      const saved = await autorizarIncidenciaGeneral(key);
      if (saved) {
        const _data = await getIncidenciasGenerales();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Concepto de Incidencia',
      dataIndex: 'tipos_de_evaluacion_de_asistencia',
      key: 'tipos_de_evaluacion_de_asistencia',
      width: 200,
      render: (_, record) => record?.tipos_de_evaluacion_de_asistencia?.map((e) => e.nombre).join(', ') || ''
      ,
    },
    {
      titleText: 'Máximo de Incidencias',
      dataIndex: 'limite_maximo',
      key: 'limite_maximo',
      width: 200,
    },
    {
      titleText: 'Días Máximo para Justificar',
      dataIndex: 'dias_maximo_para_justificar',
      key: 'dias_maximo_para_justificar',
      width: 300,
    },
    {
      titleText: 'Texto para NO Justificaciones',
      dataIndex: 'texto_para_no_justificaciones',
      key: 'texto_para_no_justificaciones',
      width: 300,
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 150,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 180,
      render: (_, record) => record?.estados_globales?.descripcion || 'n/a',
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };
  const handleMaxIncidencias = (e) => {
    const rawValue = e.target.value;

    // Remove all non-digit characters
    let filtered = rawValue.replace(/\D/g, '');

    // Limit to 2 digits
    if (filtered.length > 2) {
      filtered = filtered.slice(0, 2);
    }

    // Update the form field manually
    form.setFieldsValue({ limite_maximo: filtered });
  };
  const handleNumbers = (e) => {
    const rawValue = e.target.value;

    // Remove all non-digit characters
    const filtered = rawValue.replace(/\D/g, '');

    // Update the form field manually
    form.setFieldsValue({ dias_maximo_para_justificar: filtered });
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'incidenciageneral', action: 'autorizar' },
                icon: <CheckCircleOutlined />,
                text: 'Autorizar',
                disabledBySelection: true,
                disabled: selectedData?.estados_globales?.id !== ESTATUS_ACTIVO,
                className: 'success',
              },
            ]}
            disableDelete={selectedData?.estados_globales?.id !== ESTATUS_ACTIVO}
            permission={permission}
            allowExportParam={false}
            allowSearch={false}
          />
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Incidencias Para Reloj Checador`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrorDatePicker
              name="general"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
              }}
            >
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="tipos_de_evaluacion_de_asistencia"
                  label="Concepto de Incidencia"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    mode="multiple"
                    labelProp="nombre"
                    keyProp="id"
                    dataSource={evaluacionesAsistencia}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="limite_maximo"
                  rules={rules.required}
                  label="Máximo de Incidencias"
                  hasFeedback
                >
                  <Input
                    allowClear
                    onChange={handleMaxIncidencias}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="dias_maximo_para_justificar"
                  rules={rules.required}
                  label="Días Máximo para Justificar"
                  hasFeedback
                >
                  <Input
                    allowClear
                    onChange={handleNumbers}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="texto_para_no_justificaciones"
                  rules={rules.required}
                  label="Texto para NO Justificaciones"
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="vigencia_final"
                  label="Vigencia Final"
                  hasFeedback
                >
                  <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={isAdding || selectedData?.estados_globales?.id === ESTATUS_INACTIVO}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    activeInactive={selectedData?.estados_globales?.id === ESTATUS_ACTIVO}
                    disabled={selectedRowKeys.length <= 0 || disableFields}
                    onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`Incidencia Para Reloj Checador ${form.getFieldValue('tipos_de_evaluacion_de_asistencia')?.map((e) => e.nombre).join(', ')}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar Incidencia Para Reloj Checador ${form.getFieldValue('tipos_de_evaluacion_de_asistencia')?.map((e) => e.nombre).join(', ')}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar Incidencia Para Reloj Checador ${form.getFieldValue('tipos_de_evaluacion_de_asistencia')?.map((e) => e.nombre).join(', ')}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default IncidenciaGeneral;
